var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"id":"lang-btn","title":_vm.$t('Change Language')},on:{"click":_vm.changeLanguage}},[_c('img',{attrs:{"src":_vm.langPathImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }